import { StyleSheet } from 'aphrodite';
import { borderColor, brandSecondary } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 300,
		position: 'relative',
	},
	company: {
		alignItems: 'center',
		borderBottom: `1px solid ${borderColor}`,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		margin: '20px 0',
		padding: '10px 0',
	},
	radioButton: {
		pointerEvents: 'none',
	},
	companyNameWithEmailDomain: {
		display: 'inline-block',
		marginLeft: 10,
		marginBottom: 2,
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		maxWidth: 400,
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
		textAlign: 'center',
		marginBottom: 10,
	},
	subheader: {
		fontSize: 14,
		textAlign: 'center',
		marginBottom: 20,
	},
	list: {
		maxHeight: 400,
		overflowY: 'auto',
		flexGrow: 1,
	},
	footer: {
		marginTop: 30,
		display: 'flex',
		gap: 10,
	},
	description: {
		fontSize: 14,
		marginBottom: 20,
	},
	companies: {
		maxHeight: 300,
		overflowY: 'auto',
	},
	companyName: {
		fontSize: 14,
	},
	domain: {
		color: '#aaa',
		fontWeight: 'normal',
	},
	buttons: {
		display: 'flex',
		gap: 10,
	},
	cancelButton: {
		padding: '8px 15px',
		background: 'none',
		border: '1px solid #ddd',
		borderRadius: 4,
		cursor: 'pointer',
		textTransform: 'capitalize',
		fontSize: 14,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	mergeButton: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
});
